import { SBOM_CONSTANTS } from './SBOM.constants';

export function isRootDependency(item) {
  return (item?.dependency?.type || item?.type) === SBOM_CONSTANTS.COMPONENT_TYPE.ROOT;
}

export function getRemovableDependencies(data) {
  if (!Array.isArray(data)) {
    return [];
  }

  return data.filter(item => !isRootDependency(item) && item?.dependency?.identificationIds?.length > 0);
}

export function getIdentificationsFromDependencies(data) {
  return getRemovableDependencies(data).flatMap(item => item.dependency.identificationIds);
}

export function getBulkRemovalSelection(data) {
  const removableRows = getRemovableDependencies(data);
  const hasRoot = Array.isArray(data) && data.some(isRootDependency);

  return {
    removableRows,
    identificationIds: getIdentificationsFromDependencies(removableRows),
    count: removableRows.length,
    hasRoot,
    canRemove: !hasRoot && removableRows.length > 0
  };
}

export function getDependencyFormValues(initialValues) {
  return {
    name: initialValues.name || '',
    vendor: initialValues.vendor || '',
    version: initialValues.version || '',
    type: initialValues.type || '',
    licenses: initialValues.license || [],
    cpes: initialValues.cpes || [],
    purls: initialValues.purls || [],
    identifierInput: '',
    identifierInputError: '',
    description: initialValues.description || initialValues.dependency?.description || '',
    reason: initialValues.latestRemediation?.reason || ''
  };
}

export function getDependencyFields(data, isRootEdit) {
  return {
    name: data.name,
    type: isRootEdit ? SBOM_CONSTANTS.COMPONENT_TYPE.ROOT : data.type,
    vendor: data.vendor,
    version: data.version,
    license: data.licenses,
    cpes: Array.from(new Set(data.cpes)),
    purls: Array.from(new Set(data.purls)),
    description: data.description
  };
}

function normalizeScalar(value) {
  return value == null ? '' : String(value);
}

function normalizeList(value) {
  if (!Array.isArray(value)) return [];
  return [...value].map(normalizeScalar).sort();
}

function listsEqual(a, b) {
  const left = normalizeList(a);
  const right = normalizeList(b);
  if (left.length !== right.length) return false;
  return left.every((item, index) => item === right[index]);
}

/** True when edit form differs from baseline on fields other than description/reason. */
export function hasMeaningfulDependencyEdits(current, baseline) {
  if (!current || !baseline) return false;

  if (normalizeScalar(current.identifierInput).trim()) return true;

  const scalarFields = ['name', 'vendor', 'version', 'type'];
  if (scalarFields.some(field => normalizeScalar(current[field]) !== normalizeScalar(baseline[field]))) {
    return true;
  }

  if (!listsEqual(current.licenses, baseline.licenses)) return true;
  if (!listsEqual(current.cpes, baseline.cpes)) return true;
  if (!listsEqual(current.purls, baseline.purls)) return true;

  return false;
}
